
interface InputProps {
  type?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  label?: string;
  icon?: string;
}

export default function Input({
  type = 'text',
  placeholder,
  value,
  onChange,
  className = '',
  required = false,
  disabled = false,
  label,
  icon
}: InputProps) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-zinc-200 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <i className={`${icon} text-zinc-500 text-sm`}></i>
          </div>
        )}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          className={`w-full px-4 py-3 ${icon ? 'pl-10' : ''} border border-zinc-700 rounded-lg focus:ring-2 focus:ring-accent-400 focus:border-transparent transition-all duration-200 text-sm text-zinc-100 placeholder:text-zinc-500 ${disabled ? 'bg-zinc-800 cursor-not-allowed' : 'bg-zinc-900'} ${className}`}
        />
      </div>
    </div>
  );
}
